//
// TextLayoutBuilder
//
// Based on view info from a layout

import { observer } from 'mobx-react-lite'
import { useStore } from '../../../../stores'

import { Icon, Text } from '../../../../components'

export const TextLayoutBuilder = observer(function TextLayoutBuilder({
    className,
    component,
    components,
    layout,
    record,
    worksheet,
    active_class,
    visited_gids,
}) {
    const { app } = useStore()

    const language = worksheet.environment.get('language')
    let attributes = { className: 'layout-component ws-text' }
    if (className) attributes['className'] += ' ' + className
    if (component.style) attributes['className'] += ' lc-' + component.style
    if (component.gid === worksheet.layoutstore.selectedComponentGid) {
        attributes['className'] += ' cc-selected'
    }

    const text = component.text ? (
        component.text[language]
    ) : (
        <>
            <Icon size="text" name="text" /> {app.text('<not set>')}
        </>
    )
    attributes['onClick'] = () => worksheet.layoutstore.selectComponent(component.gid)
    return <Text {...attributes}>{text}</Text>
})
